import React, { useContext, useState } from 'react';
import { Wrapper } from '@accesa/react-core/build/layout/wrapper';
import { MainLayout } from '@accesa/react-core/build/layout/mainLayout';
import {
  AppContext,
  AppContextProvider,
  defaultAppContext,
} from '../../AppContext';
import AppHeader from '../../components/appHeader';
import App from '../../App';
import AppAuth from '../appAuth';
import S from './styled';
import { isAuthenticated } from '../../services/authService';

export const AppWrapper: React.FC = (): React.ReactElement => {
  const [userAuthLoggedInStatus, setUserAuthLoggedInStatus] = useState<boolean>();
  const { userManager } = useContext(AppContext);

  const getAuthStatus = async () => {
    const isUserAuthenticated = await isAuthenticated(userManager);
    if (isUserAuthenticated) {
      return true;
    } else {
      return false;
    }
  };

  const authLoggedInStatus = getAuthStatus();
  authLoggedInStatus.then(status => {
    setUserAuthLoggedInStatus(status);
  });

  return (
    <S.ContainerStyle>
        {userAuthLoggedInStatus ? (
          <AppContextProvider value={defaultAppContext}>
            <Wrapper
              id="l2care"
              setHeader={
                <AppHeader />
              }
              setMain={<MainLayout isFluid={true} children={<App />} />}
              setFooter={<AppAuth />}
            />
          </AppContextProvider>
        ) : (
          <Wrapper
            id="l2care-unauthorized"
            setHeader={<></>}
            setMain={<MainLayout isFluid={true} children={<App />} />}
          />
        )}
    </S.ContainerStyle>
  );
};
